const brand = {
    state: {
        domain: '',
        title: '',
        describe: '',
        logo: '',
        copyright: '',
        im_app: '',
        download_app: '',
        spread: '',
        demo_alert: '',
        independent: '',
        invitation_code: '',
        basic_teaching: '',
        menu_fentu_hidden: false,
        is_custom_cash: false,
        extend: [],
        extend_data: {},
        is_hidden: ''
    },
    mutations: {
        BRAND_SET_DOMIN: (state, domain) => {
            state.domain = domain
        },
        BRAND_SET_TITLE: (state, title) => {
            state.title = title
        },
        BRAND_SET_DESCRIBE: (state, describe) => {
            state.describe = describe
        },
        BRAND_SET_LOGO: (state, logo) => {
            state.logo = logo
        },
        BRAND_SET_COPYRIGHT: (state, copyright) => {
            state.copyright = copyright
        },
        BRAND_SET_IMAPP: (state, im_app) => {
            state.im_app = im_app
        },
        BRAND_SET_DOWNLOADAPP: (state, download_app) => {
            state.download_app = download_app
        },
        BRAND_SET_SPREAD: (state, spread) => {
            state.spread = spread
        }, 
        BRAND_SET_DEMOALERT: (state, demo_alert) => {
            state.demo_alert = demo_alert
        },
        BRAND_SET_INDEPENDENT: (state, independent) => {
            state.independent = independent
        },
        BRAND_SET_INVITATIONCODE: (state, invitation_code) => {
            state.invitation_code = invitation_code
        },
        BRAND_SET_BASICTEACHING: (state, basic_teaching) => {
            state.basic_teaching = basic_teaching
        },
        BRAND_SET_MENUFENTUHIDDEN: (state, menu_fentu_hidden) => {
            state.menu_fentu_hidden = menu_fentu_hidden
        },
        BRAND_SET_ISCUSTOMCASH: (state, is_custom_cash) => {
            state.is_custom_cash = is_custom_cash
        },
        BRAND_SET_EXTEND: (state, extend) => {
            state.extend = extend
        },
        BRAND_SET_EXTEND_DATA: (state, extend_data) => {
            state.extend_data = extend_data
        },
        BRAND_SET_ISHIDDEN: (state, is_hidden) => {
            state.is_hidden = is_hidden
        },
    },
    actions: {
        brandSetBrand({ commit }, brand) {
            commit('BRAND_SET_DOMIN', brand.domain)
            commit('BRAND_SET_TITLE', brand.title)
            commit('BRAND_SET_DESCRIBE', brand.describe)
            commit('BRAND_SET_LOGO', brand.logo)
            commit('BRAND_SET_COPYRIGHT', brand.copyright)
            commit('BRAND_SET_IMAPP', brand.im_app)
            commit('BRAND_SET_DOWNLOADAPP', brand.download_app)
            commit('BRAND_SET_SPREAD', brand.spread)
            commit('BRAND_SET_DEMOALERT', brand.demo_alert)
            commit('BRAND_SET_INDEPENDENT', brand.independent)
            commit('BRAND_SET_INVITATIONCODE', brand.invitation_code)
            commit('BRAND_SET_BASICTEACHING', brand.basic_teaching)
            commit('BRAND_SET_MENUFENTUHIDDEN', brand.menu_fentu_hidden)
            commit('BRAND_SET_ISCUSTOMCASH', brand.is_custom_cash)
            commit('BRAND_SET_EXTEND', brand.extend)
            commit('BRAND_SET_EXTEND_DATA', brand.extend_data)
            commit('BRAND_SET_ISHIDDEN', brand.is_hidden)
        }
    }
}

export default brand
